export class UnauthorizedError extends Error {
	status = 401;

	constructor(cause) {
		super('Unauthorized');
		this.name = 'UnauthorizedError';
		this.cause = cause;
	}
}
